import {useCount} from "../Hooks/useCount";

const CountPage = () => {
    const {count} =useCount();
    const backGroundImage = localStorage.getItem('backgroundURL')

    return(
        <div style={{
            backgroundImage: `url("${backGroundImage}")`
        }} className="min-w-full text-white font-bold h-screen overflow-hidden bg-countPage bg-cover flex flex-col justify-center items-center ">
            <h1 className="text-2xl mb-5 drop-shadow-textshadowDark"> شرکت کنندگان </h1>
            <p className=" text-3xl drop-shadow-textshadowDark "> {count} </p>
            <p className="-mb-3 mt-4 text-2xl drop-shadow-textshadowDark"> نفر</p>
        </div>
    )
}
export default CountPage;
